var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.875 9.48828V12.2633C13.875 14.6033 11.6925 16.5008 9 16.5008C6.3075 16.5008 4.125 14.6033 4.125 12.2633V9.48828C4.125 11.8283 6.3075 13.5008 9 13.5008C11.6925 13.5008 13.875 11.8283 13.875 9.48828Z",
    stroke: "#0047FF",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.875 5.7375C13.875 6.42 13.6875 7.05 13.3575 7.59C12.555 8.91 10.905 9.75 9 9.75C7.095 9.75 5.445 8.91 4.6425 7.59C4.3125 7.05 4.125 6.42 4.125 5.7375C4.125 4.5675 4.6725 3.51 5.55 2.745C6.435 1.9725 7.65 1.5 9 1.5C10.35 1.5 11.565 1.9725 12.45 2.7375C13.3275 3.51 13.875 4.5675 13.875 5.7375Z",
    stroke: "#0047FF",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.875 5.7375V9.4875C13.875 11.8275 11.6925 13.5 9 13.5C6.3075 13.5 4.125 11.8275 4.125 9.4875V5.7375C4.125 3.3975 6.3075 1.5 9 1.5C10.35 1.5 11.565 1.9725 12.45 2.7375C13.3275 3.51 13.875 4.5675 13.875 5.7375Z",
    stroke: "#0047FF",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.61cf21e1674243379afe2cd7c22b1da1.svg";
export { ForwardRef as ReactComponent };